import FormProgress from './form-progress';
import './form-progress.scss';

export default FormProgress;
